export var LocalizationItem;
(function (LocalizationItem) {
  LocalizationItem["Hello"] = "Hello";
  LocalizationItem["SignOut"] = "SignOut";
  LocalizationItem["UpgradeToConsultant"] = "UpgradeToConsultant";
  LocalizationItem["UpgradeToBrandPartner"] = "UpgradeToBrandPartner";
})(LocalizationItem || (LocalizationItem = {}));